"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _Link = _interopRequireDefault(require("@material-ui/core/Link"));

var _Breadcrumbs = _interopRequireDefault(require("@material-ui/core/Breadcrumbs"));

var _NavigateNext = _interopRequireDefault(require("@material-ui/icons/NavigateNext"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _ArrowBack = _interopRequireDefault(require("@material-ui/icons/ArrowBack"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    flexWrap: "nowrap",
    maxWidth: "100%"
  },
  back: {
    marginLeft: theme.spacing(1),
    "& + $breadcrumbs": {
      marginLeft: theme.spacing(1)
    },
    [theme.breakpoints.up('sm')]: {//            display: "none"
    }
  },
  breadcrumbs: {
    marginLeft: theme.spacing(2),
    fontFamily: "Akkurat, sans-serif",
    fontSize: "18px",
    fontWeight: "bold",
    lineHeight: "24px",
    color: theme.palette.primary.main,
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    "& a:hover": {
      cursor: "pointer"
    },
    "& li[aria-hidden=true]": {
      marginLeft: theme.spacing(.5),
      marginRight: theme.spacing(.5)
    },
    [theme.breakpoints.down('sm')]: {
      "& li": {
        display: "none"
      },
      "& li:last-child": {
        display: "block",
        maxWidth: "100%",
        overflow: "hidden",
        textOverflow: "ellipsis"
      }
    }
  },
  identifier: {
    /*        display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            */
    whiteSpace: "nowrap",
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    color: theme.palette.primary.main
  },
  prefix: {
    fontFamily: "Akkurat, sans-serif",
    fontSize: "18px",
    fontWeight: "bold",
    lineHeight: "24px",
    marginRight: theme.spacing(1),
    [theme.breakpoints.down('xs')]: {
      display: "none"
    }
  },
  icon: {
    marginRight: theme.spacing(1)
  },
  parent: {
    display: "flex",
    color: theme.palette.text.primary
  },
  title: {
    fontFamily: "Akkurat, sans-serif",
    fontSize: "18px",
    lineHeight: "24px",
    "&[data-title=true]": {
      fontWeight: "bold"
    },
    "&[data-status=new]": {//            fontWeight: "normal",
    }
  },
  subtitle: {
    fontFamily: "Akkurat, sans-serif",
    fontSize: "18px",
    lineHeight: "24px",
    marginLeft: theme.spacing(1)
  },
  uniqueId: {
    fontFamily: "Akkurat Mono, monospace",
    fontSize: "16px",
    lineHeight: "24px",
    textTransform: "uppercase",
    marginLeft: theme.spacing(1),
    color: theme.palette.text.secondary
  }
}));

const ButtonBack = ({
  label,
  onClick
}) => {
  const classes = useStyles();
  return _react.default.createElement(_IconButton.default, {
    className: classes.back,
    onClick: onClick
  }, _react.default.createElement(_ArrowBack.default, null));
};

const EditorPath = ({
  className,
  status,
  parents = [],
  title,
  subtitle,
  identifier,
  untitled = "Uten tittel",
  onSelect,
  onBack
}) => {
  const classes = useStyles();

  const handleSelect = (item, event) => {
    if (onSelect) {
      onSelect(item, event);
    }
  };

  const handleBack = event => {
    if (onBack) {
      onBack(event);
    }
  };

  if (parents && parents.length) {
    return _react.default.createElement("div", {
      className: className
    }, _react.default.createElement(ButtonBack, {
      className: classes.back,
      onClick: event => handleBack(event)
    }), _react.default.createElement(_Breadcrumbs.default, {
      className: classes.breadcrumbs,
      separator: _react.default.createElement(_NavigateNext.default, null)
    }, parents && parents.map((parent, index) => {
      return _react.default.createElement(_Link.default, {
        className: classes.parent,
        noWrap: true,
        onClick: event => handleSelect(parent, event),
        key: index
      }, parent.title);
    }), _react.default.createElement(_Typography.default, {
      className: classes.identifier,
      "data-status": status,
      noWrap: true
    }, _react.default.createElement("b", {
      className: classes.title,
      "data-status": status,
      "data-title": title && true
    }, title || untitled), subtitle && _react.default.createElement("i", {
      className: classes.subtitle
    }, subtitle), identifier && _react.default.createElement("i", {
      className: classes.uniqueId
    }, identifier))));
  }

  return _react.default.createElement("div", {
    className: className
  }, _react.default.createElement(ButtonBack, {
    onClick: event => handleBack(event)
  }), _react.default.createElement(_Breadcrumbs.default, {
    className: classes.breadcrumbs,
    separator: _react.default.createElement(_NavigateNext.default, null)
  }, _react.default.createElement(_Typography.default, {
    className: classes.identifier,
    "data-status": status,
    noWrap: true
  }, _react.default.createElement("b", {
    className: classes.title,
    "data-status": status,
    "data-title": title && true
  }, title || untitled), subtitle && _react.default.createElement("i", {
    className: classes.subtitle
  }, subtitle), identifier && _react.default.createElement("i", {
    className: classes.uniqueId
  }, identifier))));
};

var _default = EditorPath;
exports.default = _default;
module.exports = exports.default;